import type { IColorScheme } from './IColorScheme';

/**
 * Резервне збереження вибраної схеми в localStorage (`po.colorScheme.v1` = {"id","mode"}): його читає вбудований скрипт index.html,
 * щоб виставити data-scheme / data-mode до першого малювання, і застосунок — поки сервер (GET /me) ще не відповів.
 */
const KEY = 'po.colorScheme.v1';

/** Ключ схеми, збережений у браузері, або null (приватний режим, перший вхід). */
export function readStoredColorScheme(): string | null {
  try {
    const raw = localStorage.getItem(KEY);
    const value: unknown = raw ? JSON.parse(raw) : null;
    return value && typeof value === 'object' && typeof (value as { id?: unknown }).id === 'string' ? (value as { id: string }).id : null;
  } catch {
    return null;
  }
}

/** Зберігає ключ і режим схеми; помилки сховища ігноруються (схема однаково застосована до документа). */
export function storeColorScheme(scheme: IColorScheme): void {
  try { localStorage.setItem(KEY, JSON.stringify({ id: scheme.id, mode: scheme.mode })); } catch { /* сховище недоступне */ }
}
